import { fetch, Storage } from 'scripts/utils'
import { ExpirePublishedEntryMutation } from 'scripts/constants'
import getStorageKey from '../utils/getStorageKey'

const expirePublishedEntry = (urlToken: string): Promise<any> => {
  return new Promise((resolve) => {
    fetch({
      input: {
        query: ExpirePublishedEntryMutation,
        variables: {
          formId:
            Storage.getItem(getStorageKey('publishedFormToken', urlToken)) ||
            Storage.getItem(getStorageKey('urlPublishedFormToken', urlToken)),
          publishedEntryId: Storage.getItem(getStorageKey('publishedEntryId', urlToken)),
        },
      },
      successCallback: ({ data }) => {
        resolve(data)
      },
    })
  })
}

export default expirePublishedEntry
